import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getModule } from './module';

export const ReduxInitLoadable: React.FC<{}> = () => {
  return <DynamicModuleLoader modules={[getModule()]} />;
};
ReduxInitLoadable.displayName = 'DeviationSubmitReduxLoadable';

export default ReduxInitLoadable;
